import { useTheme } from '../context/ThemeContext';

const items = [
  'Custom Software', 'Web Applications', 'Mobile Apps', 'AI & Machine Learning',
  'Cloud Solutions', 'E-Commerce', 'Data Analytics', 'Business Intelligence',
  'CRM Integration', 'Web Hosting', 'Chatbots & AI Assistants', 'Database Management',
];

export default function Marquee() {
  const { colors } = useTheme();
  const doubled = [...items, ...items];
  const s = {
    wrapper: {
      background: colors.bg2,
      borderTop: `1px solid ${colors.border}`,
      borderBottom: `1px solid ${colors.border}`,
      padding: '1rem 0', overflow: 'hidden',
    },
    track: {
      display: 'flex', gap: '3rem', width: 'max-content',
      animation: 'marquee 35s linear infinite',
    },
    item: {
      display: 'flex', alignItems: 'center', gap: '0.8rem', whiteSpace: 'nowrap',
      fontSize: '0.78rem', fontWeight: 500, letterSpacing: '2px',
      textTransform: 'uppercase', color: colors.muted,
    },
    dot: { width: '5px', height: '5px', background: colors.text, borderRadius: '50%', flexShrink: 0 },
  };

  return (
    <div style={s.wrapper}>
      <div style={s.track}>
        {doubled.map((item, i) => (
          <div key={i} style={s.item}>
            <span style={s.dot} />
            {item}
          </div>
        ))}
      </div>
      <style>{`
        @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .marquee-track { animation: marquee 35s linear infinite; }
      `}</style>
    </div>
  );
}
